module.exports = __webpack_public_path__ + "static/media/img4.2b3c094a.png";